var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isloaded)?_c('div',{staticClass:"page-loader"},[_c('div',{staticClass:"cube"}),_c('div',{staticClass:"cube"}),_c('div',{staticClass:"cube"}),_c('div',{staticClass:"cube"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }